export enum ModuleNames {
    Doctor = 1,
    Registration,
    Administration,
    Masters,
    OrganizationSetting,
    PaymentMasters,
    Reports,
    Inventory
}